<template>
    <div>
        <div class="logo">
            <router-link :to="linkHome"><img src="../../../assets/img/amol1.png"></router-link>
        </div>
        <ul class="menu">
            <li class="parent">
                <a href="https://tienda.agendaenlinea.cl/" target="_blank">Pago en Linea</a>
            </li>
            <li class="parent">
                <router-link
                    :to="{ name: 'askbox' }"
                    v-on:click.native="toggle"
                    active-class="active" exact>
                    Solicitar BOX
                </router-link>
            </li>
            <li class="parent">
                <router-link
                    :to="{ name: 'bidbox_internal' }"
                    v-on:click.native="toggle"
                    active-class="active" exact>
                    Ofrecer BOX
                </router-link>
            </li>
            <li class="parent">
                <router-link
                    :to="{ name: 'patientscoords' }"
                    v-on:click.native="toggle"
                    active-class="active" exact>
                    Pacientes
                </router-link>
            </li>
            <li class="parent" v-for="(option,index) in options" :key="option.id">
                <router-link
                    v-if="!option.submenu && option.visible"
                    v-on:click.native="toggle"
                    active-class="active" exact
                    :to="{ path: linkOption(option) }">{{option.name}}
                </router-link>
                <a v-else-if="option.submenu && option.visible"
                   href="javascript:void(0)"
                   @click="open(index, option.perms.length)"
                   class="dropdown">
                    <span>{{ option.name }}</span>
                    <span class="icon_caret">
                        <i aria-hidden="true" class="md-icon md-list-expand-indicator md-theme-default material-icons">keyboard_arrow_right</i>
                    </span>
                </a>
                <ul v-if="option.submenu && option.perms" class="submenu">
                    <li
                        v-for="(submenu, index) in option.perms"
                        v-if="showSubMenu(submenu)"
                        :key="index">
                        <router-link
                            v-on:click.native="toggle"
                            :to="{ path: linkOptionSubMenu(submenu) }"
                            active-class="active" exact>
                            {{submenu.display_name}}
                        </router-link>
                    </li>
                </ul>
            </li>
        </ul>
        <!-- <div class="divider"></div> -->
        <div class="language">
            <span class="icon"><md-icon>language</md-icon></span>
            <md-select name="language" id="language" v-model="lang" @change="updateLang">
                <md-option :value="language.code" v-for="language in languages" :key="language.id">{{ language.name }}</md-option>
            </md-select>
        </div>
    </div>
</template>
<script>
    import { doctor } from '../../../config/api.js';
    export default {
        data() {
            return {
                active: false,
                prefix: this.$route.params.country
            }
        },
        computed: {
            // Get options user
            options(){
                return this.$store.getters.user.options;
            },
            // Get linkhome
            linkHome(){
                if(this.$store.getters.user.type == 'healt_provider'){
                    return '/' + this.prefix + '/office';
                }else{
                    return '/' + this.prefix + '/doctor';
                }
            },
            // Get language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            },
            // Get Languages
            languages() {
                return this.$store.getters.language.languages;
            },
            // Get user
            user() {
                return this.$store.getters.user;
            }
        },
        methods: {
            // Update Lang
            updateLang(lang){
                let url = doctor.api.lang.set;
                this.$http.post(url,{ lang: lang }, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    })
                    .then(response => {
                        this.$store.dispatch('setLang', lang);
                        this.$lang.setLanguage(lang);
                    });
            },
            // Open
            open(id, length) {
                var id = id+4;
                var el = document.getElementsByClassName('parent')[id];
                var height = 55 * length;
                this.active = !this.active;
                if(this.active){
                    el.firstChild.className = 'dropdown active';
                    el.lastChild.className = 'submenu show';
                    el.lastChild.style.maxHeight = height + 'px';
                    el.firstChild.lastChild.firstChild.innerHTML = 'keyboard_arrow_down';
                }else{
                    el.firstChild.className = '';
                    el.lastChild.className = 'submenu';
                    el.lastChild.style.maxHeight = '0';
                    el.firstChild.lastChild.firstChild.innerHTML = 'keyboard_arrow_right';
                }
            },
            // Toggle sidebar
            toggle() {
                if(window.innerWidth <= 1190){
                    this.$emit('toggleSidebar')
                }
            },
            // Link option
            linkOption(option){
                let arr = option.perms[0].name.split('/');
                if(arr.length > 0)
                {
                    return '/' + this.prefix + '/' + arr[0];
                }
                return '/' + this.prefix + '/' + option.perms[0].name;
            },
            // Link option submenu
            linkOptionSubMenu(submenu){
                return '/' + this.prefix + '/' + submenu.name;
            },
            // Show submenu
            showSubMenu(submenu){
                let arr = submenu.name.split("/");
                if(arr[0] != 'subordinate')
                {
                    if(arr[1] == 'edit')
                    {
                        return false;
                    }
                    return true;
                }else{
                    if(arr[1] && arr[1] != 'role')
                    {
                        return false;
                    }
                    return true;
                }
            }
        }
    }
</script>
<style lang="stylus" scoped>
    @import '../../../assets/styles/mixins.styl'
    @import '../../../assets/styles/variables/color.styl'
    .logo
        height 80px
        background-color color_header
        display flex
        justify-content center
        align-items center
        text-align center
        img
            max-width 80%
    .menu
        list-style-type none
        margin 2.5em 0 0 0
        padding 0
        height calc(100vh - (80px + 2.5em + 80px))
        overflow-y auto
        li
            margin 0
            a
                display block
                padding 1em 2.5em
                transition(all 0.35s ease)
                color color_text_sidebar
                text-shadow 0 1px 2px rgba(0,0,0,0.15)
            a:hover
                background rgba(0,0,0,0.1)
                text-decoration none
                color white
            a.active
                color white
                background color_main
        .icon_caret
            float right
        .submenu
            list-style-type none
            max-height 0
            overflow hidden
            padding 0
            transition all 0.6s
            &.show
                overflow hidden
            li
                padding 0.5em 0 0 2.5em
                a
                    border-radius 0.5em 0 0 0.5em
        .divider
            margin .5em 0
            width 100%
            height 1px
            background rgba(255,255,255,0.08)
        .row
            display block
            width 100%
</style>
<style lang="stylus">
div.language
    padding 1em 2.5em
    line-height 2.25em
    display flex
    color #a2a8b4!important
    .icon
        margin-right .5em
    .md-select
        min-width 0
        width 75px
        color #a2a8b4!important
        .md-select-value
            color #a2a8b4!important
</style>



// WEBPACK FOOTER //
// Sidebar.vue?167c96f5